import { PropsWithChildren } from 'react';
import styles from './Table.module.css';
import classNames from 'classnames';

type Props = PropsWithChildren & {
  narrow?: boolean;
  dimmed?: boolean;
  strikethrough?: boolean;
};

export function Row(props: Props) {
  const { children, narrow = false, dimmed = false, strikethrough = false } = props;

  return (
    <tr
      className={classNames({
        [styles.narrow]: narrow,
        [styles.dimmed]: dimmed,
        [styles.strikethrough]: strikethrough,
      })}
    >
      {children}
    </tr>
  );
}
